import { GlobalStateManager } from './global-state-manager';
import { AppStateManager } from './app-state-manager';
export { AppStateManager } from './app-state-manager';
export { StateEvents } from './types';
export * from './react/provider';
export * from './react/hooks';
// (!) Keep in sync with README and feature-service-types.ts!
var requiredFeatureServices = {
    'locale-service': '^1.0.0',
    'layer-manager': '^2.4.0',
    'onegraph-service': '^1.0.0',
};
// (!) Keep in sync with README and feature-service-types.ts!
var optionalFeatureServices = {
    's2:logger': '^1.0.0',
    's2:async-ssr-manager': '^1.0.0',
    's2:serialized-state-manager': '^1.0.0',
};
/**
 * Small helper to easily define an AuthServiceProvider for your personal FeatureHub
 * @param options
 */
export function defineStateManagerService(options) {
    return {
        id: 'audi:configuratorStateManager',
        dependencies: {
            featureServices: requiredFeatureServices,
        },
        optionalDependencies: {
            featureServices: optionalFeatureServices,
        },
        create: function (env) {
            var _a, _b;
            var localeService = env.featureServices['locale-service'];
            var logger = env.featureServices['s2:logger'] || console;
            var asyncSsrManager = env.featureServices['s2:async-ssr-manager'];
            var serializedStateManager = env.featureServices['s2:serialized-state-manager'];
            var oneGraphClient = env.featureServices['onegraph-service'].getApolloClient();
            var layerManager = env.featureServices['layer-manager'];
            var language = localeService.language, countryCode = localeService.countryCode;
            var carlineID2Urls = options.carlineID2Urls;
            /**
             * Singleton of the state manager
             */
            var globalStateManager = new GlobalStateManager({
                brand: 'A',
                country: countryCode,
                language: language,
                carlineId: options.carlineId,
            }, oneGraphClient, carlineID2Urls, language, countryCode, {
                logger: logger,
                asyncSsrManager: asyncSsrManager,
                layerManager: layerManager,
                serializedStateManager: serializedStateManager,
            }, {
                debug: Boolean(options.debug),
                enableSimpleConflictResolution: Boolean(options.enableSimpleConflictResolution),
                enableUserSession: Boolean((_a = options.enableUserSession) !== null && _a !== void 0 ? _a : true),
                configAssistantVersion: options.configAssistantVersion,
                enableSingleQueryMode: (_b = options.enableSingleQueryMode) !== null && _b !== void 0 ? _b : true,
            });
            logger.debug('Created and initilized global state manager for carline', options.carlineId);
            return {
                '1.0.0': function (featureAppId) {
                    logger.debug('Created and initilized app state manager for featureapp', featureAppId, options.carlineId);
                    return {
                        featureService: new AppStateManager(featureAppId, globalStateManager, logger),
                        unbind: function () { return globalStateManager.unsubscribe(featureAppId); },
                    };
                },
            };
        },
    };
}
//# sourceMappingURL=index.js.map